import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Skeleton, Stack, Typography } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { MapPanel, MapPanelHeader, MapPanelScrollableArea } from "~/modules/map/components/MapPanel";

import ProjectReviewVisitV2ObservationListItemSkeleton from "./ProjectReviewVisitV2ObservationListItem/ProjectReviewVisitV2ObservationListItemSkeleton";

type ProjectReviewVisitV2ObservationListSkeletonProps = {
    backHref: string;
};

export function ProjectReviewVisitV2ObservationListSkeleton({
    backHref,
}: ProjectReviewVisitV2ObservationListSkeletonProps) {
    const { t } = useTranslation("project");
    return (
        <MapPanel>
            <MapPanelHeader>
                <IconButton component={Link} color="inherit" to={backHref}>
                    <ArrowBack />
                </IconButton>
                <Stack paddingBlock={1} flexGrow={1}>
                    <Typography variant="h6">{t("projectReviewVisitV2.observationsRoute.title")}</Typography>
                </Stack>
            </MapPanelHeader>
            <MapPanelScrollableArea sx={{ padding: 0 }}>
                {/* observation groups */}
                {[1, 2, 3].map(groupIndex => (
                    <Fragment key={groupIndex}>
                        {/* Group header */}
                        <Box
                            padding={2}
                            sx={theme => ({
                                borderBottom: `1px solid ${theme.palette.divider}`,
                                backgroundColor: theme.palette.background.default,
                            })}
                        >
                            <Skeleton variant="text" width={150} height={20} />
                        </Box>
                        {/* Observation items in group */}
                        {[1, 2].map(itemIndex => (
                            <ProjectReviewVisitV2ObservationListItemSkeleton key={itemIndex} />
                        ))}
                    </Fragment>
                ))}
            </MapPanelScrollableArea>
            <Box
                padding={2}
                sx={theme => ({
                    borderTop: `1px solid ${theme.palette.divider}`,
                })}
            >
                <Skeleton variant="rectangular" width="100%" height={40} />
            </Box>
        </MapPanel>
    );
}
